import SimpleSchema from 'simpl-schema'

export default {
  _id: {
    type: String,
    visibility: false
  },
  name: {
    label: 'Nombre',
    type: String
  },
  uniqueId: {
    label: 'Identificador',
    type: String
  },
  image: {
    label: 'Foto <strong style="font-size: 14px;">(64x64)px</strong>',
    type: SimpleSchema.Any,
    optional: true,
    image: true,
    height: 64,
    width: 64,
  },
};
